import type { ApiSchemas } from '@rental/contracts/client'
import type { StaffLocale } from '@rental/domain'
import { countryName, format, formatDate, type StaffMessages } from '@rental/i18n'

type Reason = ApiSchemas['StaffBookingDetail']['eligibilityReasons'][number]

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

/** An eligibility reason in staff words, its dates and country spelled out. */
export function reasonText(reason: Reason, locale: StaffLocale, m: StaffMessages): string {
  const params: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(reason.params)) {
    if (value === null) continue
    if (key === 'country' && typeof value === 'string') params[key] = countryName(locale, value)
    else if (typeof value === 'string' && ISO_DATE.test(value))
      params[key] = formatDate(locale, value, 'short')
    else params[key] = value
  }
  return format(m.eligibilityReasons[reason.code], params)
}
